export default {
  title: "評価項目管理画面",
  cardTitle: "検索条件",
  from: "期間",
  to: "期間",
  manageRole: "本部長・部長・MGR",
  userRole: "担当者",
  chooseRole: "役職選択",
  addBtn: "新規登録",
  searchLabel: {
    department: "本部署",
    period: "期間",
    creator: "設定者",
    approver: "承認者",
    periodStatus: "状態",
  },
};
